import Stock from '../../../components/Main/Stock/Stock'
import StockForm from '../../../components/Main/Stock/StockForm'
import React from 'react'
import { Modal } from 'antd'
import FooterButtons from '../../../elements/Buttons/FooterButtons'

function StockModal (props) {
  const { visible, submitting, submit, update, formRef, onCancel, removing, isUpdatable, isRemovable, isNew } = props

  return (
    <Modal
      visible={visible}
      title={'Stock'}
      style={{ zIndex: 999 }}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          visible={isUpdatable}
          removing={removing}
          submit={submit}
          update={update}
          submitting={submitting}
          title={'Stock'}
          isNew={isNew}
          isEdit={!isNew}
          isRemovable={isRemovable}
        />
      }
      width={'75%'}>
      <StockForm ref={formRef} {...props} />
    </Modal>
  )
}

StockModal.propTypes = {}
StockModal.defaultProps = {
  actions: [],
  defaultTab: 'form',
  fetchingActions: false,
}

export default StockModal
